import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const isFor = ['Madres trabajadoras con horarios de oficina exigentes.', 'Mujeres que buscan nutrición real para sus hijos sin sacrificar su salud mental.', 'Quienes compran en supermercados locales y no tienen acceso a tiendas orgánicas costosas.', 'Madres cansadas de la guerra matutina en la cocina.'];
const isNotFor = ['Personas que disfrutan pasar 2 horas cocinando cada mañana.', 'Quienes tienen chef privado o ayuda dedicada exclusivamente a la cocina.', 'Madres que buscan recetas de alta cocina o emplatados artísticos de restaurante.'];
export function WhoIsFor() {
  return <section className="bg-[#FFF8F0] py-20 px-6" data-id="element-206">
      <div className="max-w-6xl mx-auto" data-id="element-207">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-208">
          {/* Para ti si... */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-[#2D6A4F]" data-id="element-209">
            <h3 className="font-heading text-2xl font-bold text-[#2D6A4F] mb-8 flex items-center" data-id="element-210">
              <span className="bg-[#2D6A4F]/10 p-2 rounded-lg mr-3" data-id="element-211">
                <CheckIcon className="text-[#2D6A4F]" size={24} data-id="element-212" />
              </span>
              Para ti si...
            </h3>
            <ul className="space-y-5" data-id="element-213">
              {isFor.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-214">
                  <CheckIcon className="text-[#2D6A4F] flex-shrink-0 mt-1" size={20} data-id="element-215" />
                  <span className="text-[#5C4B3A]" data-id="element-216">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti si... */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border-t-4 border-[#E76F51]" data-id="element-217">
            <h3 className="font-heading text-2xl font-bold text-[#E76F51] mb-8 flex items-center" data-id="element-218">
              <span className="bg-[#E76F51]/10 p-2 rounded-lg mr-3" data-id="element-219">
                <XIcon className="text-[#E76F51]" size={24} data-id="element-220" />
              </span>
              No es para ti si...
            </h3>
            <ul className="space-y-5" data-id="element-221">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-222">
                  <XIcon className="text-[#E76F51] flex-shrink-0 mt-1" size={20} data-id="element-223" />
                  <span className="text-[#5C4B3A]" data-id="element-224">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}